module.exports = __webpack_public_path__ + "static/other/starDisk.c56b0bfa.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starDisk.json
// module id = 2216
// module chunks = 0